<template>
    <div class="container">
        <content-header title="Сотрудничество со страховыми компаниями"/>
        <div class="flex">
            <img src="../../assets/images/staticPages/strah_oms.png" alt="strah_oms" width="225" height="160">
            <div>
                <p style="text-indent: 20px;">Благодаря высокому уровню медицинского обслуживания, заботу о Вашем
                    здоровье нам доверяют крупнейшие
                    страховые компании в сфере обязательного медицинского страхования (ОМС) и добровольного медицинского
                    страхования (ДМС).</p>
                <p style="text-indent: 20px;">Чтобы узнать, входит ли ФГБУ «Поликлиника №5» в перечень учреждений по
                    Вашей программе добровольного медицинского страхования (ДМС), необходимо позвонить на медицинский
                    пульт Вашей страховой компании.</p>
            </div>
        </div>
        <div class="divider"></div>
        <h3>СТРАХОВЫЕ КОМПАНИИ ОМС</h3>
        <div class="inv-divider"></div>
        <p>
            <span class="bold not-inline">АО «Медицинская акционерная страховая компания» (АО «МАКС-М»)</span>
            Контакты:<br>
            Адрес юридический:115184, ул. Малая Ордынка, дом 50 (Генеральный директор)<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон: 8 (495) 786-45-31, 8 (499) 324-35-21, 8 (800) 333-60-03
        </p>
        <p>
            <span class="bold not-inline">ООО «МСК «МЕДСТРАХ»»</span>
            Контакты:<br>
            www.medstrakh.ru<br>
            Адрес юридический: 107140, Москва, ул. Верхняя Красносельская, д. 20, стр. 1<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон: 8 (495) 777-23-23, 8 (800) 775-26-36 (многоканальный)
        </p>
        <p>
            <span class="bold not-inline">ООО «Страховая медицинская компания РЕСО-МЕД» (Московский филиал)</span>
            Контакты:<br>
            msk.reso-med.com<br>
            Адрес юридический: 142500, Московская область, г. Павловский Посад, Урицкого улица, дом 26<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон: 8 (800) 200-92-04
        </p>
        <p>
            <span class="bold not-inline">АО «Страховая компания «СОГАЗ-Мед»»</span>
            Контакты:<br>
            www.sogaz-med.ru<br>
            Адрес юридический: 107045, г. Москва, пер. Уланский, дом 26, помещение 3.01<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон: 8 (800) 100-07-02
        </p>
        <p>
            <span class="bold not-inline">ООО «Страховая компания «Ингосстрах-М»</span>
            Контакты:<br>
            www.ingos-m.ru<br>
            Адрес юридический: 115035, г. Москва, ул. Пятницкая, д. 12, стр. 2<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон/факс: 8 (495) 956-41-25
        </p>
        <p>
            <span class="bold not-inline">ООО «КАПИТАЛ МС»</span>
            Контакты:<br>
            www.kapmed.ru<br>
            Адрес юридический: 115184, г. Москва, улица Большая Татарская, д. 13, стр. 19<br>
            Справочно-информационная служба (Горячая линия):<br>
            Телефон: 8 (800) 100-81-01, 8 (499) 142-72-26
        </p>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "insurance",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

span.not-inline {
    display: block;
}

</style>
